import React from "react";
import { useFopLabels } from "../hooks/useFopLabels";
import { pickFopCardHolderShortLabel } from "./fopCardHolderShortLabel";

/** layout="wrap" — багаторядковий блок (напр. широка таблиця адмін-консолі без обрізання підпису карти). */
export default function CardLabel({ fop, cardType, layout = "inline" }) {
    const { labelBySlug, fopMetaBySlug } = useFopLabels();
    const text = pickFopCardHolderShortLabel(fop, labelBySlug, fopMetaBySlug);

    const styles = {
        color:
            cardType === "black"
                ? "white"
                : cardType === "white"
                  ? "black"
                  : cardType === "novapay_fop"
                    ? "white"
                    : "white",
        backgroundColor:
            cardType === "black"
                ? "black"
                : cardType === "white"
                  ? "white"
                  : cardType === "novapay_fop"
                    ? "#007bff"
                    : cardType === "fop"
                      ? "black"
                      : cardType === "cash"
                        ? "green"
                        : "#1d5d90",
    };

    const label =
        cardType === "black"
            ? "Чорна карта"
            : cardType === "white"
              ? "Біла карта"
              : cardType === "fop"
                ? "monobank ФОП"
                : cardType === "novapay_fop"
                  ? "NovaPay"
                  : cardType === "cash"
                    ? "Cash"
                    : "Card";

    const allowWrap = layout === "wrap";

    return text ? (
        <span
            className={`text-muted small d-inline-flex align-items-center gap-1 ${allowWrap ? "flex-wrap" : ""}`}
            style={allowWrap ? { whiteSpace: "normal", maxWidth: "100%" } : { whiteSpace: "nowrap" }}
        >
            <span className={allowWrap ? "text-break" : ""}>{text} •</span>
            <span
                className={`border p-1 border-1 ${allowWrap ? "flex-shrink-0" : ""}`}
                style={{ ...styles, whiteSpace: "nowrap" }}
            >
                {label}
            </span>
        </span>
    ) : (
        <span className=" small border p-1 border-1" style={styles}>
            {label}
        </span>
    );
}
